import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { IPageProps } from './Page.types';

const Page = forwardRef<HTMLDivElement, IPageProps>(
  ({ children, title = '', meta, ...other }, ref) => (
    <>
      <Helmet>
        <title>{`${title} | AC Milan Accrediti Stampa`}</title>
        {meta}
      </Helmet>

      <Box ref={ref} height="100%" {...other}>
        {children}
      </Box>
    </>
  )
);

export { Page };
